import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
// import { SearchAcctsComponent } from '../search-accts/search-accts.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-item-subcat',
  templateUrl: './item-subcat.component.html',
  styleUrls: ['./item-subcat.component.css']
})
export class ItemSubcatComponent implements OnInit {

  // acctDialogRef: MatDialogRef<SearchAcctsComponent>;
  // public search_dialog_data = {};

  itemCats = [];
  taxes = [];

  revenueList = [];
  revenueDetail = '';
  expenseList = [];
  expenseDetail = '';
  saleRetList = [];
  saleRetDetail = '';
  purchRetList = [];
  purchRetDetail = '';


  model = {
    'table_name': 'item_subcat', 'item_subcat_id': '0', 'item_subcat_name': '', 'item_subcat_name_en': '',
    'item_cat_id': '0', 'revenue_acct_no': '0', 'expense_acct_no': '0', 'sale_ret_acct_no': '0',
    'purch_ret_acct_no': '0', 'def_tax_acct': '0', 'comment': ''
  };

  // search_revenue = {
  //   'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longField',
  //   'table_list': [{
  //     'table_name': '`sub_acct`', 'selected_no': 'acct_number',
  //     'field_list': ['acct_number', 'sub_acct_name', 'sub_acct_name_en'],
  //     'condition': " AND `sub_acct`.`acct_type_no` = '7'"
  //   }]
  // };

  // search_expense = {
  //   'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longField',
  //   'table_list': [{
  //     'table_name': '`sub_acct`', 'selected_no': 'acct_number',
  //     'field_list': ['acct_number', 'sub_acct_name', 'sub_acct_name_en'],
  //     'condition': " AND `sub_acct`.`acct_type_no` = '8'"
  //   }]
  // };

  // search_asset = {
  //   'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longField',
  //   'table_list': [
  //     {
  //       'table_name': '`sub_acct`', 'selected_no': 'acct_number',
  //       'field_list': ['acct_number', 'sub_acct_name', 'sub_acct_name_en'],
  //       'condition': " AND (`sub_acct`.`acct_type_no` = '1' OR `sub_acct`.`acct_type_no` = '2' OR `sub_acct`.`acct_type_no` = '3')"
  //     },
  //     {
  //       'table_name': '`customer`', 'selected_no': 'customer_no',
  //       'field_list': ['customer_no', 'customer_name', 'customer_name_en']
  //     },
  //     {
  //       'table_name': '`bank_account`', 'selected_no': 'acct_number',
  //       'field_list': ['acct_number', 'bank_acct_number', 'account_name', 'account_name_en']
  //     },
  //     {
  //       'table_name': '`fixed_asset`', 'selected_no': 'acct_number',
  //       'field_list': ['acct_number', 'asset_number', 'asset_name', 'asset_name_en']
  //     }]
  // };

  // search_liability = {
  //   'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longField',
  //   'table_list': [
  //     {
  //       'table_name': '`sub_acct`', 'selected_no': 'acct_number',
  //       'field_list': ['acct_number', 'sub_acct_name', 'sub_acct_name_en'],
  //       'condition': " AND (`sub_acct`.`acct_type_no` = '4' OR `sub_acct`.`acct_type_no` = '5')"
  //     },
  //     {
  //       'table_name': '`supplier`', 'selected_no': 'supplier_no',
  //       'field_list': ['supplier_no', 'supplier_name', 'supplier_name_en']
  //     },
  //     {
  //       'table_name': '`tax`', 'selected_no': 'acct_number',
  //       'field_list': ['acct_number', 'tax_name_ar', 'tax_name_en']
  //     }]
  // };

  /// labels
  // acct_income = {sub_acct_name:"بدون ", sub_acct_id:'0'};
  // acct_expens = {sub_acct_name:"بدون", sub_acct_id:'0'};
  // acct_asset = {sub_acct_name:"بدون", sub_acct_id:'0'};
  // acct_liab = {sub_acct_name:"بدون", sub_acct_id:'0'}; public dialog: MatDialog, 

  Success_Msg; Error_Msg; Cat_Name_Msg; Revenue_Acct_Msg; Expense_Acct_Msg;
  Acct_Placeholder; Main_Cat_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<ItemSubcatComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Cat_Name_Msg').subscribe((res: string) => {
      this.Cat_Name_Msg = res;
    });

    translate.get('Revenue_Acct_Msg').subscribe((res: string) => {
      this.Revenue_Acct_Msg = res;
    });

    translate.get('Expense_Acct_Msg').subscribe((res: string) => {
      this.Expense_Acct_Msg = res;
    });

    translate.get('Acct_Placeholder').subscribe((res: string) => {
      this.Acct_Placeholder = res;
    });
    // this.search_revenue['placeholder'] = this.Acct_Placeholder;
    // this.search_expense['placeholder'] = this.Acct_Placeholder;
    // this.search_asset['placeholder'] = this.Acct_Placeholder;
    // this.search_liability['placeholder'] = this.Acct_Placeholder;

    translate.get('Main_Cat_Msg').subscribe((res: string) => {
      this.Main_Cat_Msg = res;
    });
  }

  ngOnInit() {

    let query, obj;

    // get leaf income accts
    let parent_acct = this.applicationConstants.main_acct_config['income_acct'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.revenueList = data.data['list'];
        this.model['revenue_acct_no'] = this.revenueList[0]['acct_number'];
        this.revenueDetail = this.revenueList[0]['value'];
      });


    // get leaf expenses accts
    parent_acct = this.applicationConstants.main_acct_config['expenses_acct'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.expenseList = data.data['list'];
        this.model['expense_acct_no'] = this.expenseList[0]['acct_number'];
        this.expenseDetail = this.expenseList[0]['value'];
      });

    // get leaf sale return accts
    parent_acct = this.applicationConstants.main_acct_config['income_acct'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.saleRetList = data.data['list'];
        this.model['sale_ret_acct_no'] = this.saleRetList[0]['acct_number'];
        this.saleRetDetail = this.saleRetList[0]['value'];
      });

    // get leaf purchase return accts
    parent_acct = this.applicationConstants.main_acct_config['expenses_acct'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.purchRetList = data.data['list'];
        this.model['purch_ret_acct_no'] = this.purchRetList[0]['acct_number'];
        this.purchRetDetail = this.purchRetList[0]['value'];
      });

    query = this.queryList.all_itemCat;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.itemCats = data.data['list'];
      });

    query = this.queryList.all_tax_types;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.taxes = data.data['list'];
        let selObj = { 'tax_id': '0', 'acct_number': '0', 'tax_name_ar': 'بدون ضريبة', 'tax_name_en': 'Without Tax' };
        this.taxes.unshift(selObj);
      });

    if (this.dialog_data != null) {
      this.model['item_subcat_id'] = this.dialog_data;

      query = "SELECT * FROM `item_subcat` WHERE `item_subcat_id` = '" + this.model['item_subcat_id'] + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          let item_subcat_obj = data.data['list'][0];
          this.model['item_subcat_name'] = item_subcat_obj['item_subcat_name'];
          this.model['item_subcat_name_en'] = item_subcat_obj['item_subcat_name_en'];
          this.model['item_cat_id'] = item_subcat_obj['item_cat_id'];
          this.model['revenue_acct_no'] = item_subcat_obj['revenue_acct_no'];
          this.model['expense_acct_no'] = item_subcat_obj['expense_acct_no'];
          this.model['sale_ret_acct_no'] = item_subcat_obj['sale_ret_acct_no'];
          this.model['purch_ret_acct_no'] = item_subcat_obj['purch_ret_acct_no'];
          // this.model['asset_acct_no'] = item_subcat_obj['asset_acct_no'];
          // this.model['liability_acct_no'] = item_subcat_obj['liability_acct_no'];
          this.model['def_tax_acct'] = item_subcat_obj['def_tax_acct'];
          this.model['comment'] = item_subcat_obj['comment'];

          this.fillAcctField();
        });

    }
  }

  fillAcctField() {
    let query, obj;

    if (this.model['revenue_acct_no'] != '0') {
      query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.model['revenue_acct_no'] + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length > 0) {
            //(document.getElementById("search_value_0") as HTMLInputElement).value 
            this.revenueDetail = data.data['list'][0]['acct_number'] +
              "-" + data.data['list'][0]['sub_acct_name'] + "-" + data.data['list'][0]['sub_acct_name_en'];
          }
        });
    }
    else
      (document.getElementById("search_value_0") as HTMLInputElement).value = '';

    if (this.model['expense_acct_no'] != '0') {
      query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.model['expense_acct_no'] + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length > 0) {
            this.expenseDetail = data.data['list'][0]['acct_number'] +
              "-" + data.data['list'][0]['sub_acct_name'] + "-" + data.data['list'][0]['sub_acct_name_en'];
          }
        });
    }
    else
      (document.getElementById("search_value_1") as HTMLInputElement).value = '';

    if (this.model['sale_ret_acct_no'] != '0') {
      query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.model['sale_ret_acct_no'] + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length > 0) {
            this.saleRetDetail = data.data['list'][0]['acct_number'] +
              "-" + data.data['list'][0]['sub_acct_name'] + "-" + data.data['list'][0]['sub_acct_name_en'];
          }
        });
    }
    else
      (document.getElementById("search_value_2") as HTMLInputElement).value = '';

    if (this.model['purch_ret_acct_no'] != '0') {
      query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.model['purch_ret_acct_no'] + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length > 0) {
            this.purchRetDetail = data.data['list'][0]['acct_number'] +
              "-" + data.data['list'][0]['sub_acct_name'] + "-" + data.data['list'][0]['sub_acct_name_en'];
          }
        });
    }
    else
      (document.getElementById("search_value_3") as HTMLInputElement).value = '';

    // if (this.model['asset_acct_no'] != '0') {
    //   query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.model['asset_acct_no'] + "'";
    //   obj = { cmd: 'getList', query: query };

    //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //     .subscribe(data => {
    //       this.applicationConstants.appComp.hideBusyCursor();

    //       if (data.data['list'].length > 0) {
    //         (document.getElementById("search_value_2") as HTMLInputElement).value = data.data['list'][0]['acct_number'] +
    //           "-" + data.data['list'][0]['sub_acct_name'] + "-" + data.data['list'][0]['sub_acct_name_en'];
    //       }
    //       else {
    //         query = "SELECT * FROM `customer` WHERE `customer_no` = '" + this.model['asset_acct_no'] + "'";
    //         obj = { cmd: 'getList', query: query };

    //         this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //           .subscribe(data => {
    //             this.applicationConstants.appComp.hideBusyCursor();

    //             if (data.data['list'].length > 0) {
    //               (document.getElementById("search_value_2") as HTMLInputElement).value = data.data['list'][0]['customer_no'] +
    //                 "-" + data.data['list'][0]['customer_name'] + "-" + data.data['list'][0]['customer_name_en'];
    //             }
    //             else {
    //               query = "SELECT * FROM `bank_account` WHERE `acct_number` = '" + this.model['asset_acct_no'] + "'";
    //               obj = { cmd: 'getList', query: query };

    //               this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //                 .subscribe(data => {
    //                   this.applicationConstants.appComp.hideBusyCursor();

    //                   if (data.data['list'].length > 0) {
    //                     (document.getElementById("search_value_2") as HTMLInputElement).value = data.data['list'][0]['acct_number'] +
    //                       "-" + data.data['list'][0]['bank_acct_number'] + "-" + data.data['list'][0]['account_name'] + "-" +
    //                       data.data['list'][0]['account_name_en'];
    //                   }
    //                   else {
    //                     query = "SELECT * FROM `fixed_asset` WHERE `acct_number` = '" + this.model['asset_acct_no'] + "'";
    //                     obj = { cmd: 'getList', query: query };

    //                     this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //                       .subscribe(data => {
    //                         this.applicationConstants.appComp.hideBusyCursor();

    //                         if (data.data['list'].length > 0) {
    //                           (document.getElementById("search_value_2") as HTMLInputElement).value = data.data['list'][0]['acct_number'] +
    //                             "-" + data.data['list'][0]['asset_number'] + "-" + data.data['list'][0]['asset_name'] + "-" +
    //                             data.data['list'][0]['asset_name_en'];
    //                         }
    //                       });
    //                   }
    //                 });
    //             }
    //           });
    //       }
    //     });
    // }
    // else
    //   (document.getElementById("search_value_2") as HTMLInputElement).value = '';

    // if (this.model['liability_acct_no'] != '0') {
    //   query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.model['liability_acct_no'] + "'";
    //   obj = { cmd: 'getList', query: query };

    //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //     .subscribe(data => {
    //       this.applicationConstants.appComp.hideBusyCursor();

    //       if (data.data['list'].length > 0) {
    //         (document.getElementById("search_value_3") as HTMLInputElement).value = data.data['list'][0]['acct_number'] +
    //           "-" + data.data['list'][0]['sub_acct_name'] + "-" + data.data['list'][0]['sub_acct_name_en'];
    //       }
    //       else {
    //         query = "SELECT * FROM `supplier` WHERE `supplier_no` = '" + this.model['liability_acct_no'] + "'";
    //         obj = { cmd: 'getList', query: query };

    //         this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //           .subscribe(data => {
    //             this.applicationConstants.appComp.hideBusyCursor();

    //             if (data.data['list'].length > 0) {
    //               (document.getElementById("search_value_3") as HTMLInputElement).value = data.data['list'][0]['supplier_no'] +
    //                 "-" + data.data['list'][0]['supplier_name'] + "-" + data.data['list'][0]['supplier_name_en'];
    //             }
    //             else {
    //               query = "SELECT * FROM `tax` WHERE `acct_number` = '" + this.model['liability_acct_no'] + "'";
    //               obj = { cmd: 'getList', query: query };

    //               this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //                 .subscribe(data => {
    //                   this.applicationConstants.appComp.hideBusyCursor();

    //                   if (data.data['list'].length > 0) {
    //                     (document.getElementById("search_value_3") as HTMLInputElement).value = data.data['list'][0]['acct_number'] +
    //                       "-" + data.data['list'][0]['tax_name_ar'] + "-" + data.data['list'][0]['tax_name_en'];
    //                   }
    //                 });
    //             }
    //           });
    //       }
    //     });
    // }
    // else
    //   (document.getElementById("search_value_3") as HTMLInputElement).value = '';
  }

  changeItemCat() {
    if (this.model['item_cat_id'] != '0') {
      let query = "SELECT * FROM `item_cat` WHERE `item_cat_id` = '" + this.model['item_cat_id'] + "'";
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          this.model['revenue_acct_no'] = data.data['list'][0]['revenue_acct_no'];
          this.model['expense_acct_no'] = data.data['list'][0]['expense_acct_no'];
          this.model['sale_ret_acct_no'] = data.data['list'][0]['sale_ret_acct_no'];
          this.model['purch_ret_acct_no'] = data.data['list'][0]['purch_ret_acct_no'];

          // this.model['asset_acct_no'] = data.data['list'][0]['asset_acct_no'];
          // this.model['liability_acct_no'] = data.data['list'][0]['liability_acct_no'];
          this.model['def_tax_acct'] = data.data['list'][0]['def_tax_acct'];

          this.fillAcctField();
        });
    }
  }

  onChangeRevenue = function (acct_number: string) {
    console.log(acct_number);
    this.model['revenue_acct_no'] = acct_number;
  }

  onChangeExpense = function (acct_number: string) {
    this.model['expense_acct_no'] = acct_number;
  }

  onChangeSaleRet = function (acct_number: string) {
    this.model['sale_ret_acct_no'] = acct_number;
  }

  onChangePruchRet = function (acct_number: string) {
    this.model['purch_ret_acct_no'] = acct_number;
  }

  // onChangeAsset = function (search_result: object) {
  //   this.model['asset_acct_no'] = (search_result['no'] != '' ? search_result['no'] : '0');
  // }

  // onChangeLiability = function (search_result: object) {
  //   this.model['liability_acct_no'] = (search_result['no'] != '' ? search_result['no'] : '0');
  // }

  // searchAcct(caller) {
  //   this.acctDialogRef = this.dialog.open(SearchAcctsComponent, {
  //     hasBackdrop: false,
  //     height: '500px',
  //     width: '600px',
  //     data: this.search_dialog_data
  //   });
  //   this.acctDialogRef
  //     .afterClosed()
  //     .subscribe(result => {
  //       if(caller == 'acct_income')
  //         this.acct_income = result;
  //       else if(caller == 'acct_expens')
  //         this.acct_expens = result;
  //       else if(caller == 'acct_asset')
  //         this.acct_asset = result;
  //       else if(caller == 'acct_liab')
  //         this.acct_liab = result;
  //         //console.log(this.acct_income);
  //     });
  // }

  add() {
    if (this.model['item_cat_id'] == '0') {
      alert(this.Main_Cat_Msg);
      (document.getElementById("item_cat_id") as HTMLInputElement).focus();
    }
    else if (this.model['item_subcat_name'] == '') {
      alert(this.Cat_Name_Msg);
      (document.getElementById("item_subcat_name") as HTMLInputElement).focus();
    }
    else if (this.model['revenue_acct_no'] == '0') {
      alert(this.Revenue_Acct_Msg);
      (document.getElementById("search_value_0") as HTMLInputElement).focus();
    }
    else if (this.model['expense_acct_no'] == '0') {
      alert(this.Expense_Acct_Msg);
      (document.getElementById("search_value_1") as HTMLInputElement).focus();
    }
    else {
      let values = [];
      // this.model['revenue_acct_id'] = this.acct_income['sub_acct_id'];
      // this.model['expense_acct_id'] = this.acct_expens['sub_acct_id'];
      // this.model['asset_acct_id'] = this.acct_asset['sub_acct_id'];
      // this.model['liability_acct_id'] = this.acct_liab['sub_acct_id'];
      values.push(this.model);
      console.log(values);

      let obj;
      if (this.model['item_subcat_id'] == '0')
        obj = { cmd: 'add', values: values };
      else {
        let where = [{ 'item_subcat_id': this.model['item_subcat_id'] }];
        obj = { cmd: 'update', values: values, where: where };
      }

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            // this.dialog_data = {
            //   'status': data.status['type']
            // };
            this.dialog_data = { 'op_type': 'success' };
            this.dialogRef.close(this.dialog_data);
          }
          else
            alert(this.Error_Msg);
        });
    }
  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }

}
